import { Drawer } from "antd";
import { useMemo } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import {
  ClearIconDrawer,
  HamburgerIcon,
  HamburgerSetingsIcon,
} from "../../assets/icons";
import "./Mobile-Menu.scss";
import { useSelector } from "react-redux";
import KonfigurimetMenu from "../../components/Konfigurimet/KonfigurimetMenu/KonfigurimetMenu";
import { useAuth } from "../../authentication/authHelpers";
import Sidebar from "../../components/Sidebar/Sidebar";

function HamburgerMenu() {
  const { userAccess } = useAuth();
  const { pathname } = useLocation();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  useMemo(() => {
    if (pathname) {
      onClose();
    }
  }, [pathname]);

  return (
    <>
      <div className="hamburgerMenu" onClick={showDrawer}>
        {pathname.startsWith("/konfigurimet") === true ? (
          <HamburgerSetingsIcon />
        ) : (
          <HamburgerIcon />
        )}
      </div>

      <Drawer
        className={`menu-drawer ${isDarkMode ? "dark darkDrawer" : ""}`}
        title="Menu"
        placement="left"
        destroyOnHidden={true}
        onClose={onClose}
        open={visible}
        closeIcon={
          <ClearIconDrawer fill={isDarkMode ? "#e6e6e6" : "#1d3445"} />
        }
        key="left"
      >
        <div>
          {pathname.startsWith("/konfigurimet") === true ? (
            <KonfigurimetMenu data={userAccess} />
          ) : (
            <Sidebar data={userAccess} />
          )}
        </div>
      </Drawer>
    </>
  );
}

export default HamburgerMenu;
